class InvalidAuthSessionError extends Error {
   constructor(errorMessage = '') {
      super(errorMessage || 'Invalid Auth Session Details')
   }
}

export { InvalidAuthSessionError }
